import DynamicIcon from "./dynamic-icon";

const SearchItem = ({ children, icon, isPrompt, onClick }) => {
    return (
        <div
            className={`group flex items-center justify-between px-[13px] py-[4.5px] hover:custom-bg-white-200 cursor-pointer`}
            onClick={onClick} >
            <div className="flex items-center gap-[8px]">
                 <DynamicIcon name={isPrompt ? 'sparkles' : icon} size={18} />
                <p className="poppins-medium text-[13px] custom-text-grey-900">{children}</p>
            </div>
            {isPrompt ? (
            <DynamicIcon name='send-horizontal' size={16} color='hidden group-hover:block'/>
        ) :(
            <DynamicIcon name='arrow-right' size={16}/>
        )
            }
        </div>
    );
}
export default SearchItem;